import crosstab from 'crosstab';
import { getJwtToken } from '../modules/jwtTokenManager.js';

const WS_DEBUG = false;
const MAX_TOKEN_RETRIES = 5;
const MAX_RETRY_DELAY = 30;

function wsLog(message, data) {
    if (WS_DEBUG) {
        if (data !== undefined) {
            console.log(message, data);
        } else {
            console.log(message);
        }
    }
}

window["prepareNotification"] = function (entity) {
    // skip THREAD_SYNC_MESSAGE and FEED_SYNC_MESSAGE types
    if (entity.type === 'THREAD_SYNC_MESSAGE' || entity.type === 'FEED_SYNC_MESSAGE') {
        return null;
    }

    let data = entity.data,
        sender = entity.sender,
        cdn = '//ipstatic.net/';

    // default value When Sender is null...
    let thumb = cdn + 'images/male-empty-profile.png';

    let notification = {}

    if (sender) {
        if (sender.avatar) {
            thumb = sender.avatar.thumb_small;
        } else if (sender.sex) {
            thumb = cdn + 'images/' + sender.sex + '-empty-profile.png';
        }

        notification = {
            url: '/' + sender.username,
            username: sender.username,
            img_url: thumb,
            img_dims: "width='50' height='50'",
        };
    }

    /**
     * We don't use some notifications because it's rly hard to support in legacy:
     *
     * FEED_SYNC_MESSAGE
     * THREAD_SYNC_MESSAGE
     */
    switch (entity.type) {
        case 'COMMENT_MESSAGE':
            notification.title = window.t ? window.t('common.push_new_feed_comment') : 'New comment on your feed';
            notification.text = data.message;

            return notification;
        case 'COMMENT_REPLY_MESSAGE':
            notification.title = window.t ? window.t('common.push_comment_reply') : 'New reply to your comment';
            notification.text = data.message;

            return notification;
        case 'FRIEND_ACCEPT_MESSAGE':
            notification.title = window.t ? window.t('common.push_friend_accepted', {username: sender.username}) : sender.username + ' accepted your friendship!';
            notification.text = window.t ? window.t('common.push_say_hi') : "Say 'Hi'!";

            return notification;
        case 'BIRTHDAY_MESSAGE':
            notification.title = window.t ? window.t('common.push_birthday_today', {username: sender.username}) : sender.username + '`s birthday today';
            notification.text = window.t ? window.t('common.push_congratulate_birthday') : "Congratulate your friend on birthday!";

            return notification;
        case 'FRIEND_JOIN_MESSAGE':
            notification.title = window.t ? window.t('common.push_friend_joined', {username: sender.username}) : sender.username + ' just joined';
            notification.text = window.t ? window.t('common.push_say_hi') : "Say 'Hi'!";

            return notification;
        case 'FRIEND_REQUEST_MESSAGE':
            notification.title = window.t ? window.t('common.push_friend_request', {username: sender.username}) : sender.username + ' requested your friendship';
            notification.text = window.t ? window.t('common.push_say_hi') : "Say 'Hi'!";

            return notification;
        case 'LOGIN_NOTIFICATION':
            notification.title = window.t ? window.t('common.push_user_online', {username: sender.username}) : sender.username + ' is online';
            notification.text = window.t ? window.t('common.push_say_hi') : "Say 'Hi'!";

            return notification;
        case 'LIKE_MESSAGE':
            // @todo
            break;
        case 'PHOTO_COMMENT':
            notification.url = '/app/photo?pid=' + data.target_id;
            notification.title = window.t ? window.t('common.push_new_photo_comment', {username: sender.username}) : 'New photo comment from ' + sender.username;
            notification.text = data.snippet ? data.snippet : data.message;
            notification.text = escapeHtml(notification.text);

            return notification;
        case 'THREAD_NEW_MESSAGE':
            notification.url = '/pm.php?thread_id=' + data.thread_id;
            notification.thread_id = data.thread_id;
            notification.title = window.t ? window.t('common.push_new_message', {username: sender.username}) : 'New message from ' + sender.username;
            notification.text = data.snippet ? data.snippet : data.message;
            notification.text = escapeHtml(notification.text);

            return notification;
        case 'THREAD_VIEWED':
            // @todo: handle in pm
            break;

        case 'WALL_MESSAGE':
            notification.url = '/app/wall';
            notification.title = window.t ? window.t('common.push_new_wall_post') : 'New post on your wall';
            notification.img_url = data.thumb;
            notification.text = data.snippet ? data.snippet : data.message;
            notification.text = escapeHtml(notification.text);

            return notification;
    }

    return null;
}

window["escapeHtml"] = function (text) {
    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, function (m) {
        return map[m];
    });
}

window["onMessage"] = function (wsMessage) {
    let data;
    try {
        data = JSON.parse(wsMessage.data);

        if (!data || typeof data !== 'object') {
            throw new Error('Invalid message format');
        }
    } catch (e) {
        wsLog('Failed to parse WebSocket message', e);
        return;
    }

    if (data.type === 'COUNTER_UPDATE') {
        if (!data.id || typeof data.id !== 'string') {
            wsLog('Invalid COUNTER_UPDATE message - missing or invalid id');
            return;
        }

        switch (data.id) {
            case 'wpNewCnt':
            case 'frNewCnt':
            case 'pmNewCnt':
            case 'ncNewCnt':
            case 'phNewCnt':
                $('#' + data.id).text('+' + data.value).show();
                break;
        }
    } else {
        const notification = prepareNotification(data);

        if (notification && window.enable_notifs) {
            window.showNotifications([notification])
        }
    }
}

$(document).ready(function () {
    var retryCount = 0;
    var tokenRetryCount = 0;
    var isConnecting = false;
    var currentWs = null;

    var connect = function () {
        if (isConnecting || currentWs) {
            wsLog('[WebSocket] Already connecting or connected, skipping');
            return false;
        }

        // Check if user is logged in by looking for user-id meta tag
        const userIdMeta = document.querySelector('meta[name="user-id"]');
        if (!userIdMeta || !userIdMeta.getAttribute('content')) {
            wsLog('[WebSocket] Not logged in, skipping connection');
            return false;
        }

        wsLog('[WebSocket] Starting connection attempt');

        var wspath = 'wss://api.interpals.net/v1/ws';

        if (document.location.hostname === 'local.interpals.net' || document.location.hostname === 'localhost') {
            wspath = 'ws://' + document.location.host + '/v1/ws';
        }

        // Get JWT token from localStorage
        const tokenData = getJwtToken();
        if (!tokenData || !tokenData.auth || !tokenData.auth.token) {
            if (tokenRetryCount >= MAX_TOKEN_RETRIES) {
                wsLog('[WebSocket] Token not available after max retries, giving up');
                return false;
            }
            wsLog('[WebSocket] No token available yet, retrying in 1 second');
            tokenRetryCount++;
            setTimeout(function() {
                connect();
            }, 1000);
            return false;
        }

        tokenRetryCount = 0;
        wspath += '?token=' + tokenData.auth.token;

        isConnecting = true;
        var ws = new WebSocket(wspath);
        currentWs = ws;

        ws.onopen = function () {
            retryCount = 0;
            isConnecting = false;
            wsLog('[WebSocket] Connected successfully');
        };

        if (crosstab.supported) {
            ws.onmessage = function (event) {
                crosstab.broadcast('ws:message', event)
            };
        } else {
            ws.onmessage = onMessage;
        }

        ws.onclose = function (event) {
            currentWs = null;
            isConnecting = false;

            var retryTimeout = Math.min(Math.pow(2, retryCount), MAX_RETRY_DELAY);
            retryCount++;

            wsLog('[WebSocket] Connection closed (code: ' + event.code + '), retrying in ' + retryTimeout + ' seconds');

            setTimeout(
                function () {
                    connect()
                },
                retryTimeout * 1000
            );
        };

        ws.onerror = function (error) {
            wsLog('[WebSocket] Connection error', error);
            isConnecting = false;
        };
    };

    function cleanup() {
        if (currentWs) {
            wsLog('[WebSocket] Cleaning up connection');
            currentWs.close(1000, 'Page unload');
            currentWs = null;
        }
        isConnecting = false;
        retryCount = 0;
        tokenRetryCount = 0;
    }

    window.addEventListener('beforeunload', cleanup);
    window.addEventListener('pagehide', cleanup);

    if (crosstab.supported) {
        crosstab.on('ws:message', function (event) {
            onMessage(event.data);
        });

        const isMaster = crosstab.util.tabs.MASTER_TAB.id === crosstab.id;
        if (isMaster) {
            wsLog("master - connecting");
            connect();
        }

        crosstab.on(crosstab.util.eventTypes.becomeMaster, function (message) {
            wsLog("elected new master - connecting");
            connect();
        });
    } else {
        connect()
    }
});
